import React, { Suspense, lazy } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { LayoutSplashScreen } from "../../../_metronic";
import { useLastLocation } from "react-router-last-location";
import * as builder from "../../../_metronic/ducks/builder";

// Apollo Client
import keys from "../../../config/keys";
import ApolloClient from "apollo-boost";
import { getCsrfToken } from '@utils/common';
import { gql } from "apollo-boost";

const ItsmPage = lazy(() =>
  import("./itsm/ItsmPage")
);
const ReaderPage = lazy(() =>
  import("./reader/ReaderPage")
);
const AdminPage = lazy(() =>
  import("../admin/AdminPage")
);
const ToolsPage = lazy(() =>
  import("../tools/ToolsPage")
);
const ProjectManagementPage = lazy(() =>
  import("../project_management/ProjectManagementPage")
);

const ReleaseManagementPage = lazy(() =>
  import("../release_management/ReleaseManagementPage")
);

const MyProfile = lazy(() =>
  import("../admin/MyProfile")
);

const GET_DEVICES = gql`
  query (
    $tag: String 
    $tenant: String 
    $managed_by_itpoint: Boolean
    $manufacturer: String
    $role: String
    $has_primary_ip: Boolean
    $status: String
    ){
      AllDevices (
        tag: $tag 
        tenant: $tenant 
        managed_by_itpoint: $managed_by_itpoint
        manufacturer: $manufacturer
        role: $role
        has_primary_ip: $has_primary_ip
        status: $status
        ){
          id
          display_name
          name
          primary_ip {
            id
            address
          }
          site {
            id
            name
          }
          tenant {
            id
            name
          }
          custom_fields {
            api_token_ro
            mgmt_https_port
          }
      }
    }
  `
  ;

const prefixtoip = (prefix) => {
  var fip_array = prefix.split("/");
  var fip_ip = fip_array[0];
  return fip_ip;
}

function HomeContent(props) {

  const dispatch = useDispatch();

  const { user } = useSelector(state => ({
    user: state.auth.user,
  }), shallowEqual);

  const client = new ApolloClient({
    uri: keys.graphqluri,
    credentials: "include",
    request: (operation) => {
      operation.setContext({
        headers: {
          "X-CSRF-Token": getCsrfToken(),
        },
      });
    },
  });

  var userPermissions = user.userPermissions;

  const loadData = () => {
    // Update the menu with the firewall links
    client.query({
      query: GET_DEVICES,
      variables: { limit: 1000, role: 'firewall', managed_by_itpoint: true, has_primary_ip: true, status: 'active' },
    }).then(fw_res => {
      var links = {};
      fw_res.data.AllDevices.forEach(device => {
        if (!device.tenant?.name) console.log(device.name);
        links[device.tenant.name] = links[device.tenant.name] || {
          title: device.tenant.name,
          alignment: "right",
          toggle: "click",
          icon: "flaticon2-folder",
          permission: 'tools-links-firewall',
          submenu: []
        };
        links[device.tenant.name].submenu.push({
          title: device.name,
          bullet: "dot",
          externalLink: true,
          page: `https://${prefixtoip(device.primary_ip.address)}:${device.custom_fields?.mgmt_https_port || '443'}`,
          permission: 'tools-links-firewall',
        });
      });
      var newMenu = {
        header: {
          self: {},
          items: [
            {
              title: "Dashboards",
              root: true,
              icon: "flaticon2-architecture-and-city",
              alignment: "left",
              page: "dashboard",
              translate: "MENU.DASHBOARD",
              permission: 'main-dashboard'
            },
            {
              title: "ITSM",
              alignment: "left",
              // bullet: "line",
              toggle: "click",
              root: true,
              icon: "flaticon2-rocket",
              page: "itsm/tickets",
              permission: 'itsm'
            },
            {
              title: "Tools",
              root: true,
              alignment: "left",
              toggle: "click",
              icon: "flaticon2-tools-and-utensils",
              permission: 'tools',
              submenu: [
                /* {
                  title: "Links",
                  alignment: "right",
                  toggle: "click",
                  icon: "flaticon2-folder",
                  permission: 'tools-links',
                  submenu: [
                    {
                      title: "Firewall",
                      alignment: "right",
                      toggle: "click",
                      icon: "flaticon2-folder",
                      permission: 'tools-links-firewall',
                      submenu: Object.values(links)
                    }
                  ]
                }, */
                {
                  title: "Visual Policy Lookup",
                  bullet: "dot",
                  page: "tools/visualpolicylookup",
                  permission: 'tools-visual-policy-lookup',
                },
                {
                  title: "Network Topology",
                  bullet: "dot",
                  page: "tools/networktopology",
                  permission: 'tools-network-topology',
                },
                {
                  title: "Device Token",
                  bullet: "dot",
                  page: "tools/devicetoken",
                  permission: 'tools-device-token',
                },
              ]
            },
            {
              title: "MAD",
              root: true,
              alignment: "left",
              //bullet: "line",
              toggle: "click",
              page: "itsm/newmadrequest",
              icon: "flaticon-laptop",
              permission: 'mad-add_request'
            }
          ]
        },
        aside: {
          self: {},
          items: [
            {
              title: "Dashboard",
              root: true,
              icon: "flaticon2-architecture-and-city",
              page: "dashboard",
              translate: "MENU.DASHBOARD",
              bullet: "dot",
              permission: 'main-dashboard'
            },
            {
              title: "ITSM",
              bullet: "line",
              icon: "flaticon2-rocket",
              page: "itsm/tickets",
              permission: 'itsm'
            },
            {
              title: "New MAD Request",
              root: true,
              alignment: "left",
              bullet: "line",
              //toggle: "click",
              page: "itsm/newmadrequest",
              icon: "flaticon-laptop",
              permission: 'mad-add_request'
            },
            { section: "Project Management" },
            {
              title: "Project Management",
              root: true,
              alignment: "left",
              toggle: "click",
              permission: 'project-management',
              icon: "flaticon2-calendar-1",
              submenu: [
                {
                  title: "Team Planner",
                  bullet: "dot",
                  page: "pm/teamplanner",
                  permission: 'project-management-team-planner',
                },
                {
                  title: "Project List",
                  bullet: "dot",
                  page: "pm/projects",
                  permission: 'project-management-view_projects',
                },
                {
                  title: "Finance Planner",
                  bullet: "dot",
                  page: "pm/financeplanner",
                  permission: 'project-management-finance-planner',
                },
              ]
            },
            {
              title: "Release Management",
              root: true,
              alignment: "left",
              toggle: "click",
              permission: 'release-management',
              icon: "flaticon2-reload",
              submenu: [
                {
                  title: "Update Planner",
                  bullet: "dot",
                  page: "rm/updateplanner",
                  permission: 'release-management-update-planner',
                }
              ]
            },
            { section: "Tools" },
            {
              title: "Tools",
              root: true,
              alignment: "left",
              toggle: "click",
              permission: 'tools',
              icon: "flaticon2-tools-and-utensils",
              submenu: [
                {
                  title: "Links",
                  alignment: "right",
                  toggle: "click",
                  icon: "flaticon2-folder",
                  permission: 'tools-links',
                  submenu: [
                    {
                      title: "Firewall",
                      alignment: "right",
                      toggle: "click",
                      icon: "flaticon2-folder",
                      permission: 'tools-links-firewall',
                      submenu: Object.values(links)
                    }
                  ]
                },
                {
                  title: "Visual Policy Lookup",
                  bullet: "dot",
                  page: "tools/visualpolicylookup",
                  permission: 'tools-visual-policy-lookup',
                },
                {
                  title: "Network Topology",
                  bullet: "dot",
                  page: "tools/networktopology",
                  permission: 'tools-network-topology',
                },
                {
                  title: "Device Token",
                  bullet: "dot",
                  page: "tools/devicetoken",
                  permission: 'tools-device-token',
                },
              ]
            },
            { separator: 'System', permission: 'main-dashboard' },
            { section: "Admin" },
            {
              title: "Admin",
              root: true,
              alignment: "left",
              toggle: "click",
              permission: 'admin',
              icon: "flaticon2-settings",
              submenu: [
                {
                  title: "Users",
                  bullet: "dot",
                  page: "admin/users",
                  permission: 'admin-users',
                },
                {
                  title: "Logged In Users",
                  bullet: "dot",
                  page: "admin/loggedinusers",
                  permission: 'admin-users',
                },
                {
                  title: "Teams",
                  bullet: "dot",
                  page: "admin/teams",
                  permission: 'admin-teams-view_team',
                },
                {
                  title: "Roles",
                  bullet: "dot",
                  page: "admin/roles",
                  permission: 'admin-roles',
                },
                {
                  title: "Project Roles",
                  bullet: "dot",
                  page: "admin/projectroles",
                  permission: 'admin-project_roles-view_project_role',
                },
                {
                  title: "Permissions",
                  bullet: "dot",
                  page: "admin/permissions",
                  permission: 'admin-permissions',
                },
                {
                  title: "Settings",
                  bullet: "dot",
                  page: "admin/config",
                  permission: 'admin-settings',
                },
                {
                  title: "Templates",
                  bullet: "dot",
                  page: "admin/templates",
                  permission: 'admin-templates',
                },
                {
                  title: "Template Categories",
                  bullet: "dot",
                  page: "admin/templatecategories",
                  permission: 'admin-template-categories',
                },
                {
                  title: "Kanban Boards",
                  bullet: "dot",
                  page: "admin/kanbanboards",
                  permission: 'admin-kanban-boards',
                },
                {
                  title: "Budget",
                  bullet: "dot",
                  page: "admin/budgets",
                  permission: 'admin-budget'
                },
                {
                  title: "MAD Requests",
                  bullet: "dot",
                  page: "admin/madrequests",
                  permission: 'admin-mad-view_requests'
                },
                {
                  title: "MAD Enabled Users",
                  bullet: "dot",
                  page: "admin/madenabledusers",
                  permission: 'admin-mad-view_requests'
                },
                {
                  title: "Sounds",
                  bullet: "dot",
                  page: "admin/sounds",
                  permission: 'admin-sounds-view_sound',
                },
                {
                  title: "Logs",
                  bullet: "dot",
                  page: "admin/logs",
                  permission: 'admin-log-view_logs',
                },
                {
                  title: "API Requests",
                  bullet: "dot",
                  page: "admin/apirequests",
                  permission: 'admin-api-audit-view_requests',
                },
              ]
            },

          ]
        }
      };
      dispatch(builder.actions.setMenuConfig(newMenu));
    }).catch(e => console.log(e));
  };

  React.useEffect(loadData, []);

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/itsm/timedashboard" />
        }
        <Redirect exact from="/dashboard" to="/itsm/timedashboard" />
        {userPermissions.indexOf('itsm') >= 0 && <Route path="/itsm" component={ItsmPage} />}
        {userPermissions.indexOf('admin') >= 0 && <Route path="/admin" component={AdminPage} />}
        {userPermissions.indexOf('tools') >= 0 && <Route path="/tools" component={ToolsPage} />}
        {userPermissions.indexOf('project-management') >= 0 && <Route path="/pm" component={ProjectManagementPage} />}
        {userPermissions.indexOf('release-management') >= 0 && <Route path="/rm" component={ReleaseManagementPage} />}
        <Route path="/reader" component={ReaderPage} />
        <Route path="/myprofile" component={MyProfile} />
        <Redirect to="/error/error-v3" />
      </Switch>
    </Suspense>
  );
}

function Loading() {
  const lastLocation = useLastLocation();
  const history = useHistory();
  const [redirected, setRedirected] = React.useState(false); // Prevent multiple redirects

  React.useEffect(() => {
    if (!redirected) {
      const targetPath = lastLocation?.pathname;

      if (
        targetPath &&
        targetPath !== "/loading" &&
        targetPath !== history.location.pathname
      ) {
        setRedirected(true);
        history.replace(targetPath);
      } else if (!targetPath && history.location.pathname !== "/") {
        setRedirected(true);
        history.replace("/");
      }
    }
  }, [lastLocation, redirected, history]);

  return <LayoutSplashScreen />;
}


export default function HomePage() {

  const { user } = useSelector(state => ({
    user: state.auth.user,
  }), shallowEqual);

  return user ?
    <HomeContent />
    :
    (
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <Route path="/loading" component={Loading} />
          <Redirect to="/loading" />
        </Switch>
      </Suspense>
    );
}